// Function to preserve all tracking parameters
export const getTrackingUrl = (
  baseUrl: string,
  sourceName: string = 'thyroid_advertorial',
) => {
  // Get all current URL parameters
  const searchParams = new URLSearchParams(window.location.search)
  // Ensure fbclid is included even if not in current URL (from localStorage)
  if (!searchParams.has('fbclid') && localStorage.getItem('fbclid')) {
    searchParams.append('fbclid', localStorage.getItem('fbclid') || '')
  }
  // Add source parameter to identify this specific advertorial
  if (!searchParams.has('utm_source')) {
    searchParams.append('utm_source', sourceName)
  }
  // Add campaign if not present
  if (!searchParams.has('utm_campaign')) {
    searchParams.append('utm_campaign', 'nivie_mineral_drops')
  }
  const queryString = searchParams.toString()
    ? `?${searchParams.toString()}`
    : ''
  return `${baseUrl}${queryString}`
}
// Track lead event
export const trackLeadEvent = (productName: string = 'Nivie Mineral Drops') => {
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: productName,
      content_category: 'Product Interest',
    })
  }
}
